import { useTranslation } from 'react-i18next';
import type { TranslateNav } from './buildMenu';

// Подписи меню, заголовки экранов и табов приходят из namespace `nav`.
// Хук нужен по двум причинам: useTranslation подписывает компонент на смену
// языка (иначе меню осталось бы на прежнем языке до следующего рендера), и он
// же сужает сигнатуру t до TranslateNav — buildMenu/buildRoutes принимают
// перевод параметром, чтобы тесты могли собрать меню чужого бренда.
export function useNavTranslate(): TranslateNav {
  const { t } = useTranslation('nav');
  return (key) => t(key);
}
